const SplitTestConstants = {
  ZRM_AI_LISTING_CREATION: 'zrm-ai-listing-creation',
} as const;

export default SplitTestConstants;
